
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"clip-rule":"evenodd","d":"M9 4.5a1.125 1.125 0 100 2.25A1.125 1.125 0 009 4.5zm0 3.375c-.621 0-1.125.503-1.125 1.125v3.375a1.125 1.125 0 002.25 0V9c0-.621-.503-1.125-1.125-1.125zM9 0C4.038 0 0 4.038 0 9s4.038 9 9 9 9-4.038 9-9-4.038-9-9-9zm0 16.313c-4.033 0-7.313-3.281-7.313-7.313S4.967 1.687 9 1.687c4.032 0 7.313 3.281 7.313 7.313S13.031 16.313 9 16.313z"}})])
          )
        }
      }
    